import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import { useState } from 'react';
import AssignmentsUsedBy from '../../questionsSearch/components/AssignmentsUsedBy';
import ActivityTypes from '../../../enums/activityTypes';
import { faSwatchbook } from '@fortawesome/free-solid-svg-icons';

const PcsVocabularyThumbnail = ({
  vocabularies, 
  setVocabularies,
  isLoading,
  showQuestionUsage,
  showDefinition,
  setIsAllSelected
}) => {
  const [showUsedByModal, setShowUsedByModal] = useState(false);
  const [usedFlashcards , setUsedFlashcards] = useState([]);

  const handleSetSelection = (questionId, selected) => {
    let newVocabularies = vocabularies.map((item) =>
      item.questionId == questionId ? { ...item, isSelected: selected } : item
    );
    setIsAllSelected(newVocabularies.every((item) => item.isSelected));
    setVocabularies(newVocabularies);
  };

  const handleUsedBy = (flashcards) => {
    setUsedFlashcards(flashcards);
    setShowUsedByModal(true);
  };

  return (
    <>
      {!isLoading ? (
        <>
          {
            vocabularies.map((item, index) => (
              <div key={index} className="pcsVocabularyCard">
                <div className="pcsVocabularyContent">
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <div className="pcsVocabularyTitle">
                      {item.number}. {item.vocabulary}
                    </div>

                    {item.usedBy.length > 0 && showQuestionUsage && (
                      <div
                        className="pcsUsageBadge"
                        onClick={() => handleUsedBy(item.usedBy)}
                      >
                        <FontAwesomeIcon icon={faSwatchbook} />
                        <span>Flashcards Using</span>
                      </div>
                    )}
                  </div>
                  {showDefinition && (
                    <div
                      className="pcsVocabularyDefinition"
                      dangerouslySetInnerHTML={{
                        __html: item.definition
                      }}
                    />
                  )}
                </div>
                <div
                  className="pcsSelectionIcon"
                  onClick={() =>
                    handleSetSelection(item.questionId, !item.isSelected)
                  }
                >
                  <FontAwesomeIcon
                    icon={item.isSelected ? faCircleCheck : faCircle}
                  />
                </div>
              </div>
            ))
          }
        </>
      ) :
        (
          <div className="w-100 row">
            {[...Array(1)].map((_, index) => (
              <div className='col-12 mb-3 h-40' key={index}>
                <Skeleton />
              </div>
            ))}
            {[...Array(4)].map((_, index) => (
              <div className='col-12 mb-3 h-40' key={index}>
                <Skeleton />
              </div>
            ))}
          </div>
        )
      }
      {showUsedByModal &&
        <AssignmentsUsedBy
          usedAssignments={usedFlashcards}
          showUsedByModal={showUsedByModal}
          setShowUsedByModal={setShowUsedByModal}
          activityType={ActivityTypes.FlashCard}
        />
      }
    </>
  );
};

PcsVocabularyThumbnail.propTypes = {
  vocabularies: PropTypes.array.isRequired,
  setVocabularies: PropTypes.func,
  isLoading: PropTypes.bool,
  showQuestionUsage: PropTypes.bool,
  showDefinition: PropTypes.bool,
  setIsAllSelected: PropTypes.func
};

export default PcsVocabularyThumbnail;
